module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 93.f01af84a.png";